// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3E1E6","ranges":"BmiRanges_ranges__Otusf"};